




import Vue, { PropType } from 'vue'
import { DeliveryFrequency } from '@/types/generated/graphql'
import XRadioGroup, {
  OptionEntry,
} from '@/components/atoms/Radio/XRadioGroup.vue'
import formatDeliveryFrequency from '@/plugins/filters/formatDeliveryFrequency'

type Props = {
  value?: DeliveryFrequency
  rules?: string | Record<string, boolean>
}

type Computed = {
  localValue?: DeliveryFrequency
  options: OptionEntry<DeliveryFrequency>[]
}

export default Vue.extend<{}, {}, Computed, Props>({
  inheritAttrs: false,
  name: 'DeliveryFrequencyPicker',
  components: { XRadioGroup },
  props: {
    value: {
      type: String as PropType<DeliveryFrequency>,
    },
    rules: {
      type: [String, Object],
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    options() {
      return [
        DeliveryFrequency.EveryWeek,
        DeliveryFrequency.EveryOtherWeek,
      ].map((value) => ({ value, label: formatDeliveryFrequency(value) }))
    },
  },
})
